export type ExternalReviewPlatform =
  | "reddit"
  | "discord"
  | "facebook"
  | "twitter"
  | "youtube"
  | "vendor_site"
  | "trustpilot"
  | "google_reviews"
  | "other";

export type SentimentMethod = "manual" | "vader" | "llm";

export const EXTERNAL_REVIEW_PLATFORMS: ExternalReviewPlatform[] = [
  "reddit",
  "discord",
  "facebook",
  "twitter",
  "youtube",
  "vendor_site",
  "trustpilot",
  "google_reviews",
  "other",
];

export const PLATFORM_LABELS: Record<ExternalReviewPlatform, string> = {
  reddit: "Reddit",
  discord: "Discord",
  facebook: "Facebook",
  twitter: "Twitter / X",
  youtube: "YouTube",
  vendor_site: "Vendor site",
  trustpilot: "Trustpilot",
  google_reviews: "Google Reviews",
  other: "Other",
};

export interface ExternalReviewAdmin {
  id: number;
  source_id: string;
  platform: ExternalReviewPlatform;
  external_id: string | null;
  url: string;
  author_handle: string | null;
  is_vendor_engagement: boolean;
  posted_at: string | null;
  scraped_at: string;
  text: string | null;
  native_rating: number | string | null;
  native_rating_scale: number | null;
  sentiment_score: number | string | null;
  sentiment_method: SentimentMethod | null;
  sentiment_model: string | null;
  sentiment_analyzed_at: string | null;
  created_at: string;
  updated_at: string;
  raw_payload: Record<string, unknown> | null;
}

export interface ExternalReviewCreate {
  platform: ExternalReviewPlatform;
  url: string;
  external_id?: string | null;
  author_handle?: string | null;
  is_vendor_engagement?: boolean;
  posted_at?: string | null;
  text?: string | null;
  native_rating?: number | null;
  native_rating_scale?: number | null;
  sentiment_score?: number | null;
  sentiment_method?: SentimentMethod | null;
  sentiment_model?: string | null;
  raw_payload?: Record<string, unknown> | null;
}

export interface ExternalReviewBulkResult {
  inserted: number;
  skipped: number;
  skipped_urls: string[];
}

export interface SentimentUpdate {
  sentiment_score: number;
  sentiment_method: SentimentMethod;
  sentiment_model?: string | null;
}

export interface ExternalReviewCount {
  total: number;
  by_platform: Record<string, number>;
  by_source: Record<string, number>;
}

export type ExternalReviewSort =
  | "scraped_at_asc"
  | "scraped_at_desc"
  | "posted_at_asc"
  | "posted_at_desc";

export interface ExternalReviewListParams {
  source_id?: string;
  platform?: ExternalReviewPlatform;
  has_text?: boolean;
  has_sentiment?: boolean;
  /** Case-insensitive substring match on review text or author handle. */
  q?: string;
  /** Case-insensitive substring match on the review url (e.g. a thread permalink). */
  url?: string;
  sort?: ExternalReviewSort;
  limit?: number;
  offset?: number;
}
